const NO_LEI_TEXT = {
  small: 'A single reason provided by the legal entity for declining to report a parent relationship.',
  full: [
    {
      title: 'NATURAL_PERSONS - ',
      desc: 'The entity is controlled by natural person(s) without any intermediate legal entity meeting the definition of accounting consolidating parent.',
    },
    {
      title: 'NON_CONSOLIDATING - ',
      desc: 'The accounting consolidation definition for parent relationship does not apply for the entity.',
    },
    {
      title: 'NO_KNOWN_PERSON - ',
      desc: 'There is no known person controlling the entity (e.g., diversified shareholding).',
    },
    {
      title: 'NON_PUBLIC - ',
      desc: 'The relationship information is non-public and therefore creates obstacles to releasing this information.',
    },
    {
      title: 'NO_LEI - ',
      desc: 'The parent does not consent to obtain an LEI or to authorize its “child entity” to obtain an LEI on its behalf.',
    },
  ],
}

const createException = (type) => ([
  {
    label: 'Non-reported Relationship Type',
    fieldId: 'RR_RELATIONSHIP_TYPE',
    jsonPath: `$.${type}Parent.exception.type`,
    type: 'STRING',
    text: 'A category of mandatory information reporting, beyond the minimum required for legal entity identification, which the legal entity declines, giving reasons and references where applicable.',
  },
  {
    label: 'Exception Reason',
    type: 'ENUM',
    inline: true,
    fieldId: 'REPEX_REASON',
    hardCodeEnum: true,
    enum: [
      'NON_PUBLIC',
      'NO_LEI',
      'NATURAL_PERSONS',
      'NON_CONSOLIDATING',
      'NO_KNOWN_PERSON',
    ],
    detailModal: false,
    jsonPath: `$.${type}Parent.exception.reason`,
    tooltipWidth: 300,
    text: NO_LEI_TEXT,
  },
  {
    label: 'Exception Reference',
    fieldId: 'REPEX_REFERENCE',
    jsonPath: `$.${type}Parent.exception.reference`,
    type: 'STRING',
    inline: true,
    detailModal: false,
    text: 'Reference to the law, regulation or other legal framework supporting the reason for declining to report a parent relationship.',
  },
])

export const categories = {
  'DIRECT_ACCOUNTING_CONSOLIDATION_PARENT': 'Relationship Not Reported (Direct Accounting Consolidation Parent)',
  'ULTIMATE_ACCOUNTING_CONSOLIDATION_PARENT': 'Relationship Not Reported (Ultimate Accounting Consolidation Parent)',
}

export const parseException = ({ reason, category, reference, }) => {
  const parentType = category === 'DIRECT_ACCOUNTING_CONSOLIDATION_PARENT' ? 'directParent' : 'ultimateParent'

  const createField = (prop, value) => ({
    value: value,
    jsonPath: `$.${parentType}.exception.${prop}`,
  })

  return [ createField('type', categories[category]), createField('reason', reason), createField('reference', reference), ]
}

export default [ ...createException('direct'), ...createException('ultimate'), ]



// WEBPACK FOOTER //
// ./src/utils/challenge/relationship-exception.js